module.exports = __webpack_public_path__ + "img/erweima.e6a5bd2b.png";